import React from 'react'

export const InputProcessingContext = React.createContext(['', () => {}])
